module.exports = __webpack_public_path__ + "static/img/noData.041d4c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/noData.png
// module id = VbHD
// module chunks = 14